/* import __COLOCATED_TEMPLATE__ from './confirm.hbs'; */
import UserFieldBase from "./base";
import TEMPLATE from "./confirm.hbs";
import { setComponentTemplate } from "@ember/component";
export default class UserFieldConfirm extends UserFieldBase {}
setComponentTemplate(TEMPLATE, UserFieldConfirm);